/**
 * Barra de navegacao de baixo.
 *
 * Restricoes de ADR-0007, todas verificadas em `navigation.test.tsx`:
 *  - no maximo 5 destinos;
 *  - alvos de 56 px ou mais, com espaco entre eles;
 *  - **icone E palavra** em todos — um icone sozinho nao diz nada a quem nao o
 *    reconhece, e a maior parte dos icones nao e reconhecivel;
 *  - o assistente e sempre visivel e e o botao dominante: falar e mais facil do
 *    que escrever, e por isso e a entrada principal.
 */
import { NavLink } from 'react-router-dom';
import { Badge } from '@flos/ui';
import type { NavItem } from '../navigation';

export interface BottomNavProps {
  items: NavItem[];
}

export function BottomNav({ items }: BottomNavProps) {
  return (
    <nav className="app-nav" aria-label="Navegação principal">
      <ul className="app-nav__list">
        {items.map((item) => (
          <li key={item.to} className="app-nav__cell">
            <NavLink
              to={item.to}
              end={item.to === '/'}
              className={({ isActive }) =>
                [
                  'app-nav__link',
                  item.emphasis ? 'app-nav__link--emphasis' : '',
                  isActive ? 'app-nav__link--active' : '',
                ]
                  .filter(Boolean)
                  .join(' ')
              }
            >
              {({ isActive }) => (
                <>
                  <span className="app-nav__icon flos-icon" aria-hidden="true">
                    {item.icon}
                  </span>
                  <span className="app-nav__label">{item.label}</span>
                  {item.badge ? <Badge count={item.badge} label="por rever" /> : null}
                  {/* Estado ativo dito por palavras, nao so pela cor. */}
                  {isActive ? <span className="flos-sr-only">. Está aqui</span> : null}
                </>
              )}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
